import noop from 'hs-lodash/noop';
import { getAudioContext } from './getAudioContext';
import { playBatchSounds } from './batch';
import { getSoundDurationInSeconds } from './getNotificationSounds';
let activeSound = null;
let stopPreviousSounds = noop;

/**
 * Play a requested notification sound.
 *
 * Will intelligently ignore the request if an existing sound is in progress unless the requested sound is a longer duration.
 * This ensures that the user is not spammed by multiple notifications sound when many arrive at once but also that the
 * notification with the longest sound is always heard in full. Can be overwritten with the `forcePlay` parameter
 *
 * @param name id of the requested sound to play
 * @param forcePlay stop any active sound and play the requested id
 */
export const playNotificationSound = async (name, forcePlay = false) => {
  let shouldReplaceActiveSound = true;
  const audioContext = await getAudioContext();
  if (audioContext === null) {
    return;
  }
  const now = Date.now();
  const requestedSoundDurationInSeconds = getSoundDurationInSeconds(name);
  if (activeSound) {
    if (now >= activeSound.stopAtTimestamp) {
      // we aren't interrupting a previous sound, it naturally finished via the passing of time
      activeSound = null;
    } else if (activeSound.durationInSeconds >= requestedSoundDurationInSeconds) {
      shouldReplaceActiveSound = false;
    }
  }
  if (shouldReplaceActiveSound || forcePlay) {
    stopPreviousSounds();
    activeSound = {
      durationInSeconds: requestedSoundDurationInSeconds,
      stopAtTimestamp: now + requestedSoundDurationInSeconds * 1000
    };
    stopPreviousSounds = playBatchSounds(audioContext, name);
  }
};
export const stopNotificationSound = () => {
  stopPreviousSounds();
  stopPreviousSounds = noop;
  activeSound = null;
};